import { createSlice } from '@reduxjs/toolkit'
import {
  listPageSessionAction,
  detailPageSessionAction,
  createPageSessionAction,
  updatePageSessionAction,
  deletePageSessionAction,
  listOrderSessionAction,
  sortOrderSessionAction,
} from './pageSession.action'

const initialState: PageSession.PageSessionState = {
  isLoading: false,
  error: null,
  sessions: {
    limit: 0,
    page: 0,
    records: [],
    total: 0,
    totalPage: 0,
  },
  session: null,
  orders: {
    limit: 0,
    page: 0,
    records: [],
    total: 0,
    totalPage: 0,
  },
}

const { actions, reducer } = createSlice({
  name: 'pageSession',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(listPageSessionAction.pending, (state, action) => {
        state.isLoading = true
      })
      .addCase(listPageSessionAction.fulfilled, (state, action) => {
        state.isLoading = false
        state.sessions = action.payload
      })
      .addCase(listPageSessionAction.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error
      })

      .addCase(detailPageSessionAction.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(detailPageSessionAction.fulfilled, (state, action) => {
        state.session = action.payload
        state.isLoading = false;
      })
      .addCase(detailPageSessionAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
      })

      .addCase(createPageSessionAction.pending, (state, action) => {
        state.isLoading = true
      })
      .addCase(createPageSessionAction.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(createPageSessionAction.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error
      })

      .addCase(updatePageSessionAction.pending, (state, action) => {
        state.isLoading = true
      })
      .addCase(updatePageSessionAction.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(updatePageSessionAction.rejected, (state, action) => {
        state.isLoading = false
        state.error = action.error
      })

      .addCase(deletePageSessionAction.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(deletePageSessionAction.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(deletePageSessionAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
      })

      .addCase(listOrderSessionAction.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(listOrderSessionAction.fulfilled, (state, action) => {
        state.orders = action.payload
        state.isLoading = false;
      })
      .addCase(listOrderSessionAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
      })

      .addCase(sortOrderSessionAction.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(sortOrderSessionAction.fulfilled, (state, action) => {
        state.isLoading = false;
      })
      .addCase(sortOrderSessionAction.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error;
      })
  },
})

export { reducer }
export default actions
